import React, { useCallback, useEffect, useState } from 'react';

import T from '@prisjakt/ui-translate';
import { UserSentimentRating } from './components/form';

import {
  trackUserSentimentCompleted,
  trackUserSentimentRate,
  trackUserSentimentOpen,
  trackUserSentimentClose,
  trackUserSentimentRateOpened,
} from './tracking';

import * as S from './styles';

type OwnProps = {
  closeUserSentiment?: () => void;
};

const UserSentiment = ({ closeUserSentiment }: OwnProps) => {
  const [hasRated, setHasRated] = useState(false);
  const [autoCloseTimer, setAutoCloseTimer] = useState<number>();

  const setRating = useCallback(
    rating => {
      setHasRated(true);
      trackUserSentimentRate(rating);
      trackUserSentimentCompleted();

      if (closeUserSentiment) {
        setAutoCloseTimer(
          window.setTimeout(() => {
            closeUserSentiment();
          }, 3000)
        );
      }
    },
    [closeUserSentiment, setHasRated]
  );

  const showRatingForm = !hasRated;
  const showThanks = hasRated;

  useEffect(() => {
    trackUserSentimentOpen();
    trackUserSentimentRateOpened();

    return () => {
      trackUserSentimentClose();
      clearTimeout(autoCloseTimer);
    };
  }, [autoCloseTimer]);

  useEffect(() => {
    trackUserSentimentOpen();
    trackUserSentimentRateOpened();

    return () => {
      trackUserSentimentClose();
      clearTimeout(autoCloseTimer);
    };
  }, [autoCloseTimer]);

  return (
    <S.UserSentiment data-test="UserSentiment">
      <S.Title>
        <T domain="user-sentiment">user-sentiment.rating-title</T>
      </S.Title>

      {showThanks && (
        <S.Thanks data-test="UserSentimentThanks">
          <T domain="user-sentiment">user-sentiment.thank-you</T>

          <S.CheckIcon size={40} />
        </S.Thanks>
      )}

      <S.FormWrapper visible={showRatingForm}>
        <UserSentimentRating setRating={setRating} />
      </S.FormWrapper>
    </S.UserSentiment>
  );
};

export default UserSentiment;
